import {
  isIe11,
  executeOnceAfterDocumentReadyWithIe11Resources,
} from 'utils/_document-ready.js'
// import Cookies from 'js-cookie'
import backToTop from '4-component/back-to-top/_index.js'
import videoTour from '4-component/video-modal/_index.js'
import galleryTabList from '2-content/content-gallery/_index.js'
import textareaCounter from '4-component/textarea-counter/_index.js'
import toggleMobileMenu from '1-template/header/_index.js'
import priceListSlider from '2-content/content-pricing/_index.js'
import vatinToggle from '4-component/user-registration-form/_index.js'
import ajaxOpenButton from 'utils/_ajax-open-button.js'
import orderNewForm from '4-component/order-new-form/_index.js'
import orderAttachments from '4-component/order-new-form/_order_attachments.js'
import closeAjaxPage from '1-template/header-ajax/_index.js'
import filterUserList from '3-section/filter-admin-user-list/_index.js'
import topbarNav from '1-template/topbar/_index.js'
import cookiePolicy from '4-component/cookie-policy/_index.js'
import accountOrderDetail from '3-section/section-account-order-detail/_index.js'
import adminOrderDetail from '3-section/section-admin-order-detail/_index.js'
import adminUserEdit from '3-section/section-admin-user-edit/_index.js'
import sortingUsers from '4-component/user-list/_index.js'
import sortingOrders from '4-component/order-list-admin/_index.js'
import sortingInvoices from '4-component/invoice-list-admin/_index.js'
import sortingAccountOrders from '4-component/order-list/_index.js'
import filterMake from 'utils/_filter.js'
import pagination from 'utils/_pagination.js'
import filterOrders from '3-section/filter-admin-order-list/_index.js'
import invoiceNew from '3-section/section-admin-invoice-new/_index.js'
import invoiceNav from '3-section/filter-admin-invoice-list/_index.js'
import invoiceTemplate from '3-section/section-admin-invoice-template/_index.js'
import notification from '4-component/notification/_index.js'
import teamPage from '2-content/content-team/_index.js'
import reviewsPage from '2-content/content-reviews/_index.js'
import registerFormMask from '3-section/section-register/_index.js'
//import snowman from '4-component/snowman/_index.js'
//import gift from '4-component/gift/_index.js'
//import easter from '4-component/easter/_index.js'
//import penguin from '4-component/penguin/_index.js'
import { convertDateManual, convertDateAuto, convertDateObject } from 'utils/_convert_date.js'

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(str, newStr){
    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
      return this.replace(str, newStr);
    }
    // If a string
    return this.replace(new RegExp(str, 'g'), newStr);
  };
}

executeOnceAfterDocumentReadyWithIe11Resources(() => {
  if (isIe11()) {
    if (window.objectFitImages) {
      window.objectFitImages()
    }
  }
  // Cookies.set('foo', 'bar')
  toggleMobileMenu()
  backToTop('back-to-top-id', '-is-hidden', 100, 'smooth')
  videoTour(
    'video-tour-open-id',
    'video-tour-close-id',
    'video-tour-modal-id',
    '-is-opened',
    '-is-modal-opened',
    'ponI8DFDaTg',
  )
  videoTour(
    'instruction-open-id',
    'instruction-close-id',
    'instruction-modal-id',
    '-is-opened',
    '-is-modal-opened',
    'rIAZ9xyMiuk',
  )
  galleryTabList('galleries-tabs', 'galleries-tabs-indicator', 'galleries-tabs-current')

  //easter()

  priceListSlider()

  filterUserList('filter-admin-user-list-toggle', 'filter-admin-user-list-block')

  filterMake('filter-send', 'filter-form', 'filter-reset', 'page-reload')
  //filterMake('filter-send', 'filter-form', 'filter-reset', 'page-reload', 'admin-user-list')
  //filterMake('filter-send', 'filter-form', 'filter-reset', 'page-reload', 'account-order-list')

  filterOrders()

  registerFormMask()

  invoiceNew()
  invoiceTemplate('#invoice-editor')

  notification()

  pagination('.pagination__pages-arrow_forward', '.pagination__pages-arrow_back', '.pagination__sort-item', '.pagination--top')
  pagination('.pagination__pages-arrow_forward', '.pagination__pages-arrow_back', '.pagination__sort-item', '.pagination--bottom')

  topbarNav('.menu-topbar__list')
  invoiceNav('.invoices-menu__list')

  convertDateAuto()

  if( document.getElementsByTagName('textarea') ) {
    var a = document.getElementsByTagName('textarea');
    [...a].forEach((e) => {textareaCounter(e)})
    //document.getElementsByTagName('textarea').forEach((e) => {textareaCounter(e)})
  }

  document.querySelectorAll('.form-field.--vatin > select').forEach((e) => {vatinToggle(e)})
  document.querySelectorAll('.order-list__open').forEach((e) => {ajaxOpenButton(
    e,
    '.order-list__body-item',
    '/{!_locale}/account/orders/{!id}',
    accountOrderDetail(
      '#order-status-history-link',
      '#order-status-history-close'
    )
  )})
  document.querySelectorAll('.order-list-admin__open').forEach((e) => {ajaxOpenButton(
    e,
    '.order-list-admin__body-item',
    '/{!_locale}/admin/orders/{!id}',
    adminOrderDetail(
      '#order-status-history-link',
      '#order-status-history-close'
    )
  )})
  document.querySelectorAll('.user-list__edit').forEach((e) => {ajaxOpenButton(
    e,
    '.user-list__body-item',
    '/{!_locale}/admin/users/{!id}/edit',
    adminUserEdit
  )})

  /*document.querySelectorAll('.user-list__delete').forEach((e) => {ajaxOpenButton(
    e,
    '.user-list__body-item',
    '/{!_locale}/admin/users/{!id}/delete',
    function(xhr) {
      let pageAjax = document.getElementById('page-ajax')
      pageAjax.innerHTML = ''
      pageAjax.classList.add('-is-hidden')
      const data = JSON.parse(xhr.response)
      document.querySelector('.user-list__body-item[data-id="' + data['id'] + '"]').remove()
    }
  )})*/

  document.querySelectorAll('#order_new_form').forEach((e) => {
    let form = e.closest('form')
    orderNewForm(form)
    window.Dropzone && orderAttachments(form)
  })
  closeAjaxPage('.header-ajax__back')
  closeAjaxPage('.header-ajax__close')

  cookiePolicy('cookie-policy-button')

  sortingUsers('.user-list__head-item')
  sortingOrders('.order-list-admin__head-item')
  sortingInvoices('.invoice-list-admin__head-item')
  sortingAccountOrders('.order-list__head-item')

  teamPage();
  reviewsPage();

  //penguin();
  //gift();
  //snowman();


  window.baguetteBox && window.baguetteBox.run('.gallery', {
    animation: 'fadeIn',
    buttons: true,
    // noScrollbars: true,
    overlayBackgroundColor: 'hsla(223, 80%, 63%, 0.5)',
    afterShow: () => {
      document.documentElement.classList.add('-is-modal-opened')
    },
    afterHide: () => {
      document.documentElement.classList.remove('-is-modal-opened')
    },
  })
}, ['/app-fix-ie11.css', '/dom4.js', '/ofi.js'])

window.addEventListener('beforeunload', () => {}, { once: true })
